import { render, staticRenderFns } from "./DownloadMobile.vue?vue&type=template&id=2ddbaa80&"
import script from "./DownloadMobile.vue?vue&type=script&lang=js&"
export * from "./DownloadMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports